import React from 'react';
import { RetakeCoHostProps } from './RetakeCoHost.type';
import { useTranslation } from 'react-i18next';
import './RetakeCoHost.scss';
import wemeetClient from '@utils/wemeetClient';
import { BOOL, HostType } from '@tencent/wemeet-websdk-next';

const RetakeCoHost: React.FC<RetakeCoHostProps> = (props) => {
  const { t } = useTranslation();
  const onRetakeCoHost = () => {
    if (props.user.id) {
      wemeetClient.hostCtrl.changeHost(props.user.id, HostType.cohost, BOOL.false);
    }
  };
  return (
    <li className="retake-co-host" onClick={onRetakeCoHost}>
      {t('撤销联席主持人')}
    </li>
  );
};

export default RetakeCoHost;
